import { LoyaltyMember } from '@teko/loyalty';

export const loyaltyMemberCacheKey = (userId: string) =>
  `loyalty-member-${userId}`;

export const readLoyaltyMemberCache = (
  userId?: string,
): LoyaltyMember | undefined => {
  if (!userId || typeof window === 'undefined') return undefined;
  try {
    const cached = localStorage.getItem(loyaltyMemberCacheKey(userId));
    return cached ? (JSON.parse(cached) as LoyaltyMember) : undefined;
  } catch {
    return undefined;
  }
};

export const writeLoyaltyMemberCache = (
  userId?: string,
  data?: LoyaltyMember,
) => {
  if (!userId || typeof window === 'undefined' || !data) return;
  try {
    localStorage.setItem(loyaltyMemberCacheKey(userId), JSON.stringify(data));
  } catch {
    // ignore quota / serialization errors
  }
};
